/* eslint-disable import/no-anonymous-default-export */
import { navigationItemType, showForDeviceType, showForUserType, showForSiteType, showForProduct, showHasNotProduct } from '../../hooks';
import { alertType } from '../../components/Alert/alertType';

export default [
    {
        label: "חיפוש מילה",
        path: "/",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.RavMilim],
        type: navigationItemType.link,
    },    
    {
        label: "חיפוש מילה",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    },  
    {
        label: "חיפוש מילה",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.RavMilim],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.temp_alert,
        },
    },  
    {
        label: "נקדן טקסט",
        path: "/nakdan",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.Nakdan],
        type: navigationItemType.link,
    },    
    {
        label: "נקדן טקסט",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
            path: "/nakdan",
        },
    },
    {
        label: "נקדן טקסט",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.Nakdan],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.temp_alert,
        },
    }, 
    {
        label: "אזור אישי",
        path: "/user",
        show_for_users: [showForUserType.external, showForUserType.privet],
        type: navigationItemType.link,
    },   
    {
        label: "אזור אישי",
        show_for_users: [showForUserType.guest],
        show_for_sites: [showForSiteType.main],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    },   
    {
        label:  "תנאי שימוש",
        path: "/license",
        type: navigationItemType.link,
    }, 
    {
        label:  "כתבו לנו",
        path: "/contact_us",
        type: navigationItemType.link,
    }, 
    {
        label: "מורפיקס",
        path: "https://www.morfix.co.il/",
        type: navigationItemType.link,
    },  
    {
        label: "תשבצון",
        path: "/crossword",
        show_for_users: [showForUserType.has_permissions],
        show_for_product:[showForProduct.RavMilim],
        type: navigationItemType.link,
    }, 
    {
        label: "תשבצון",
        show_for_users: [showForUserType.has_not_permissions],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
            path: "/crossword",
        },
    },
    {
        label: "תשבצון",
        show_for_users: [showForUserType.has_permissions],
        show_has_not_product:[showHasNotProduct.RavMilim],
        type: navigationItemType.alert,
        alert_data: {
            type: alertType.sign_up,
        },
    }, 
    {
        label:  "מספרים במילים",
        path: "/numbers",
        type: navigationItemType.link,
    },   
    {
        label: "על המילון",
        path: "/about",
        type: navigationItemType.link,
    },   
    {
        label:  "דבר העורכים",
        path: "/editors_note",
        type: navigationItemType.link,
    },   
    {
        label:  "בלוג",
        path: "https://blog.ravmilim.co.il/",
        type: navigationItemType.link,
    },    
    {
        label:  "עזרה",
        path: "https://blog.ravmilim.co.il/%d7%98%d7%99%d7%a4-%d7%98%d7%99%d7%a4%d7%94-%d7%98%d7%99%d7%a4%d7%99%d7%9d-%d7%a7%d7%98%d7%a0%d7%99%d7%9d-%d7%9c%d7%9e%d7%a0%d7%95%d7%99%d7%99-%d7%a8%d7%91-%d7%9e%d7%99%d7%9c%d7%99%d7%9d/",
        type: navigationItemType.link,
        target: "_blank",
    },    
    {
        label: "ביטול מינוי",
        path: "/contact_us",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    },
    {
        label: "מדיניות ביטולים",
        path: "/cancellation",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    },
    {
        label: "מדיניות פרטיות",
        path: "/privacy_policy",
        type: navigationItemType.link,
        show_for_devises: [showForDeviceType.pc],
    }
];